(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[684],{

/***/ 50217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ CRIMINAL_STATES_RESTRICTIONS_LINK; },
/* harmony export */   "o": function() { return /* binding */ LEGAL_RESTRICTIONS_LINK; }
/* harmony export */ });
var LEGAL_RESTRICTIONS_LINK = "https://support.rentspree.com/en/screening-restrictions-and-limitations";
var CRIMINAL_STATES_RESTRICTIONS_LINK = "https://support.rentspree.com/en/records-in-criminal-background-check";

/***/ }),

/***/ 97388:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var PAYER_TYPE = {
  LANDLORD: "landlord",
  RENTER: "renter"
};
/* harmony default export */ __webpack_exports__["Z"] = (PAYER_TYPE);

/***/ }),

/***/ 30654:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var PRICE = {
  CREDIT_REPORT: {
    // - RentSpree Pre-login
    'pre-login': 39.99,
    // - Other Partners
    'apartmentlist': 38
  },
  INCOME_VERI: {
    'pre-login': 10
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (PRICE);

/***/ }),

/***/ 68478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ ScreeningPage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/error.js
var error = __webpack_require__(12918);
// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(2804);
// EXTERNAL MODULE: ./src/components/atoms/typography/index.js + 2 modules
var typography = __webpack_require__(41289);
// EXTERNAL MODULE: ./src/components/templates/screening-step-v2/index.js + 2 modules
var screening_step_v2 = __webpack_require__(53169);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControlLabel/FormControlLabel.js + 4 modules
var FormControlLabel = __webpack_require__(58843);
// EXTERNAL MODULE: ./node_modules/@rentspree/component-2023.components.atoms.radio/dist/index.js
var dist = __webpack_require__(44226);
// EXTERNAL MODULE: ./node_modules/@rentspree/component-2023.components.atoms.radio-group/dist/index.js
var component_2023_components_atoms_radio_group_dist = __webpack_require__(76837);
// EXTERNAL MODULE: ./src/components/atoms/icon/index.js + 25 modules
var icon = __webpack_require__(48486);
// EXTERNAL MODULE: ./src/components/atoms/div/index.js
var div = __webpack_require__(26946);
// EXTERNAL MODULE: ./node_modules/@rentspree/component-2023.components.atoms.checkbox/dist/index.js
var component_2023_components_atoms_checkbox_dist = __webpack_require__(34766);
// EXTERNAL MODULE: ./src/components/atoms/space-between-wrapper/index.js
var space_between_wrapper = __webpack_require__(41717);
// EXTERNAL MODULE: ./src/styles/style-constants.js
var style_constants = __webpack_require__(73569);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/molecules/screening-option-item-v2/index.js








var priceColorGenerator = function priceColorGenerator(disabled, isSelected, partner) {
  if (disabled) return style_constants/* COLOR.softGray */.r$.softGray;
  if (!isSelected) return style_constants/* COLOR.softGray */.r$.softGray;
  return style_constants/* COLOR.secondaryPurple */.r$.secondaryPurple;
};

var ScreeningOptionItemV2 = function ScreeningOptionItemV2(_ref) {
  var value = _ref.value,
      disabled = _ref.disabled,
      isShowError = _ref.isShowError,
      label = _ref.label,
      optionPrice = _ref.optionPrice,
      toggleOption = _ref.toggleOption;
  var router = (0,next_router.useRouter)();
  var partner = router.query.partner;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(space_between_wrapper/* default */.Z, {
    style: {
      marginLeft: "10px"
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
      style: disabled ? {
        cursor: "not-allowed"
      } : {},
      label: label,
      onChange: toggleOption,
      control: /*#__PURE__*/(0,jsx_runtime.jsx)(component_2023_components_atoms_checkbox_dist/* default */.ZP, {
        checked: value,
        disabled: disabled,
        color: isShowError ? "error" : "primary"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(typography/* Text */.xv, {
      weight: "400",
      color: priceColorGenerator(disabled, value, partner),
      margin: "0px",
      size: "16px",
      children: optionPrice
    })]
  });
};

/* harmony default export */ var screening_option_item_v2 = (ScreeningOptionItemV2);
// EXTERNAL MODULE: ./src/utils/validations/base.js
var base = __webpack_require__(98337);
// EXTERNAL MODULE: ./src/constants/payer.js
var payer = __webpack_require__(97388);
// EXTERNAL MODULE: ./src/constants/price.js
var price = __webpack_require__(30654);
// EXTERNAL MODULE: ./src/constants/partner.js
var constants_partner = __webpack_require__(25191);
// EXTERNAL MODULE: ./src/stores/form-ready/index.js
var form_ready = __webpack_require__(93383);
// EXTERNAL MODULE: ./src/constants/legal-restrictions-link.js
var legal_restrictions_link = __webpack_require__(50217);
// EXTERNAL MODULE: ./src/components/molecules/button-set-v2/index.js + 1 modules
var button_set_v2 = __webpack_require__(202);
;// CONCATENATED MODULE: ./src/components/organisms/screening-option-form-v2/screening-option-form-v2.js



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
























var schema = es/* object */.Ry().shape({
  screeningOption: es/* object */.Ry().shape({
    application: (0,base/* requiredYup */.nc)(true, es/* bool */.Xg()),
    creditReport: (0,base/* requiredYup */.nc)(true, es/* bool */.Xg()),
    criminal: (0,base/* requiredYup */.nc)(true, es/* bool */.Xg()),
    eviction: (0,base/* requiredYup */.nc)(true, es/* bool */.Xg()),
    premium: (0,base/* requiredYup */.nc)(true, es/* bool */.Xg())
  }),
  payerType: (0,base/* requiredYup */.nc)(true)
});
var TuLogoWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "screening-option-form-v2__TuLogoWrapper",
  componentId: "sc-mjfpp4-0"
})(["width:80px;margin:0 8px 0 4px;position:relative;top:-5px;"]);
var LinkStyled = styled_components_browser_esm["default"].a.withConfig({
  displayName: "screening-option-form-v2__LinkStyled",
  componentId: "sc-mjfpp4-1"
})(["color:", ";font-weight:500;margin:auto 0;font-size:14px;"], style_constants/* COLOR.textBlack */.r$.textBlack);
var LegalRestrictionContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "screening-option-form-v2__LegalRestrictionContainer",
  componentId: "sc-mjfpp4-2"
})(["display:flex;flex-wrap:wrap;margin-top:5px;font-size:14px;"]);
var StyledText = (0,styled_components_browser_esm["default"])(typography/* Text */.xv).withConfig({
  displayName: "screening-option-form-v2__StyledText",
  componentId: "sc-mjfpp4-3"
})(["font-size:inherit;"]);
var WhoWillPayQuestionContainer = (0,styled_components_browser_esm["default"])(div/* default */.Z).withConfig({
  displayName: "screening-option-form-v2__WhoWillPayQuestionContainer",
  componentId: "sc-mjfpp4-4"
})(["margin:10px 0 5px 0;font-weight:600;"]);
var WhoWillPayRadioContainer = (0,styled_components_browser_esm["default"])(component_2023_components_atoms_radio_group_dist/* default */.ZP).withConfig({
  displayName: "screening-option-form-v2__WhoWillPayRadioContainer",
  componentId: "sc-mjfpp4-5"
})(["margin-left:10px;display:flex;flex-direction:row;gap:15px;"]);
var UnderLine = styled_components_browser_esm["default"].hr.withConfig({
  displayName: "screening-option-form-v2__UnderLine",
  componentId: "sc-mjfpp4-6"
})(["height:1px;background-color:#ccc;border:none;@media (max-width:520px){margin:15px 0;}"]);

var ScreeningOptionFormV2 = function ScreeningOptionFormV2(_ref) {
  var value = _ref.value,
      onSubmit = _ref.onSubmit,
      partner = _ref.partner;

  var _useState = (0,react.useState)(false),
      isFormError = _useState[0],
      setIsFormError = _useState[1];

  var _useRecoilState = (0,recoil/* useRecoilState */.FV)(form_ready/* formReadyStateV2 */.m),
      _useRecoilState2 = (0,slicedToArray/* default */.Z)(_useRecoilState, 2),
      formReady = _useRecoilState2[0],
      setFormReady = _useRecoilState2[1];

  var CREDIT_REPORT_PRICE = "$" + (price/* default.CREDIT_REPORT */.Z.CREDIT_REPORT[partner] || price/* default.CREDIT_REPORT */.Z.CREDIT_REPORT[constants_partner/* RENTSPREE_PRE_LOGIN */.L]);
  var INCOME_VERI_PRICE = "$" + price/* default.INCOME_VERI.pre-login */.Z.INCOME_VERI["pre-login"];
  var PREMIUM_PRICE = "$49.99";
  var payerTypeEventMapper = {
    "renter": "applicant",
    "landlord": "property_rep"
  };
  var screeningRestrictionEventData = {
    "data-event": "button_click",
    "data-click_text": "screening_restrictions",
    "data-location": "ts_widget"
  };

  var getScreeningOptionValue = function getScreeningOptionValue(screeningOption, field) {
    return screeningOption ? screeningOption.creditReport && screeningOption[field] : true;
  };

  var _useForm = (0,index_esm/* useForm */.cI)({
    resolver: (0,yup/* yupResolver */.X)(schema),
    defaultValues: {
      screeningOption: {
        application: getScreeningOptionValue(value === null || value === void 0 ? void 0 : value.screeningOption, 'application'),
        creditReport: getScreeningOptionValue(value === null || value === void 0 ? void 0 : value.screeningOption, 'creditReport'),
        criminal: getScreeningOptionValue(value === null || value === void 0 ? void 0 : value.screeningOption, 'criminal'),
        eviction: getScreeningOptionValue(value === null || value === void 0 ? void 0 : value.screeningOption, 'eviction'),
        premium: getScreeningOptionValue(value === null || value === void 0 ? void 0 : value.screeningOption, 'premium')
      },
      payerType: (value === null || value === void 0 ? void 0 : value.payerType) || payer/* default.RENTER */.Z.RENTER
    }
  }),
      handleSubmit = _useForm.handleSubmit,
      setValue = _useForm.setValue,
      getValues = _useForm.getValues,
      watch = _useForm.watch;

  var submitHandler = function submitHandler(data) {
    var _data$screeningOption = data.screeningOption,
        application = _data$screeningOption.application,
        creditReport = _data$screeningOption.creditReport;
    var isReadyToSubmit = application || creditReport && data.payerType;

    if (!isReadyToSubmit) {
      setIsFormError(true);
    } else onSubmit(data);
  };

  var _watch = watch("screeningOption"),
      application = _watch.application,
      creditReport = _watch.creditReport,
      criminal = _watch.criminal,
      eviction = _watch.eviction,
      premium = _watch.premium;

  var payerType = watch("payerType");
  var rentalAppOptionValue = getValues("screeningOption.application");
  var creditReportOptionValue = getValues("screeningOption.creditReport");
  var criminalOptionValue = getValues("screeningOption.criminal");
  var evictionOptionValue = getValues("screeningOption.eviction");
  var premiumOptionValue = getValues("screeningOption.premium");
  var isReadyToSubmit = application || creditReport && payerType;

  var _toggleOption = function toggleOption(optionName) {
    setIsFormError(false);
    var currentValue = getValues("screeningOption.".concat(optionName));

    if (optionName === "creditReport") {
      setValue("screeningOption.criminal", !currentValue, {
        shouldDirty: true
      });
      setValue("screeningOption.eviction", !currentValue, {
        shouldDirty: true
      });
      setValue("screeningOption.premium", !currentValue, {
        shouldDirty: true
      });
      return setValue("screeningOption.creditReport", !currentValue, {
        shouldDirty: true
      });
    }

    if (optionName === "application") {
      setValue("screeningOption.".concat(optionName), !currentValue, {
        shouldDirty: true
      });
    }

    if (creditReportOptionValue) {
      setValue("screeningOption.".concat(optionName), !currentValue, {
        shouldDirty: true
      });
    }
  };

  var mapEventAttribute = function mapEventAttribute() {
    var bundleTypeEvent = "";
    var screeningItemsEventMapper = [];
    if (premiumOptionValue) bundleTypeEvent = "premium";else {
      if (creditReportOptionValue) bundleTypeEvent = "standard";else if (rentalAppOptionValue) bundleTypeEvent = "application_only";
    }
    if (rentalAppOptionValue) screeningItemsEventMapper.push("rental_application");
    if (creditReportOptionValue) screeningItemsEventMapper.push("credit_report");
    if (criminalOptionValue) screeningItemsEventMapper.push("criminal");
    if (evictionOptionValue) screeningItemsEventMapper.push("eviction");
    if (premiumOptionValue) screeningItemsEventMapper.push("income_verification");
    return {
      "data-event": "ts_widget",
      "data-click_text": "next",
      "data-step": "screening_options",
      "data-application_payer": payerTypeEventMapper[payerType],
      "data-bundle": bundleTypeEvent,
      "data-screening_items": screeningItemsEventMapper.join(),
      "data-rental_application": rentalAppOptionValue,
      "data-credit_report": creditReportOptionValue,
      "data-criminal": criminalOptionValue,
      "data-eviction": evictionOptionValue,
      "data-income_verification": premiumOptionValue
    };
  };

  (0,react.useEffect)(function () {
    setFormReady(_objectSpread(_objectSpread({}, formReady), {}, {
      screeningOption: isReadyToSubmit
    }));
  }, [isReadyToSubmit]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(div/* default */.Z, {
    height: "100%",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("form", {
      style: {
        height: "100%"
      },
      onSubmit: handleSubmit(submitHandler),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(div/* default */.Z, {
        height: "100%",
        flex: true,
        flexColumn: true,
        spaceBetween: true,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(div/* default */.Z, {
          flex: true,
          flexColumn: true,
          style: {
            gap: "5px"
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(screening_option_item_v2, {
            id: "applicationOptionItem",
            label: "Rental Application",
            value: application,
            optionPrice: "Free",
            fieldName: "screeningOption.application",
            isShowError: isFormError,
            toggleOption: function toggleOption() {
              return _toggleOption("application");
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(screening_option_item_v2, {
            id: "creditReportOptionItem",
            label: "Credit Report & ResidentScore\xAE*",
            value: creditReport,
            optionPrice: CREDIT_REPORT_PRICE,
            fieldName: "screeningOption.creditReport",
            isShowError: isFormError,
            toggleOption: function toggleOption() {
              return _toggleOption("creditReport");
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(screening_option_item_v2, {
            id: "criminalOptionItem",
            label: "Criminal background check*",
            value: criminal,
            optionPrice: "Included",
            fieldName: "screeningOption.criminal",
            toggleOption: function toggleOption() {
              return _toggleOption("criminal");
            },
            disabled: !creditReportOptionValue
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(screening_option_item_v2, {
            id: "evictionOptionItem",
            label: "Eviction related proceedings*",
            value: eviction,
            optionPrice: "Included",
            fieldName: "screeningOption.eviction",
            toggleOption: function toggleOption() {
              return _toggleOption("eviction");
            },
            disabled: !creditReportOptionValue
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(screening_option_item_v2, {
            id: "evictionOptionItem",
            label: "Income verification report",
            value: premium,
            optionPrice: INCOME_VERI_PRICE,
            fieldName: "screeningOption.premium",
            toggleOption: function toggleOption() {
              return _toggleOption("premium");
            },
            disabled: !creditReportOptionValue
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(WhoWillPayQuestionContainer, {
              simple: true,
              size: "16px",
              color: creditReportOptionValue ? undefined : style_constants/* COLOR.softGray */.r$.softGray,
              children: "Who will pay the ".concat(premium ? PREMIUM_PRICE : CREDIT_REPORT_PRICE, " screening reports").concat(premium ? " & documents fee" : " fee", "?")
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(WhoWillPayRadioContainer, {
              value: creditReportOptionValue && payerType,
              onChange: function onChange(e, value) {
                setValue("payerType", value);
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                label: "Applicants",
                value: payer/* default.RENTER */.Z.RENTER,
                control: /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.ZP, {
                  disabled: !creditReportOptionValue
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                label: "Me",
                value: payer/* default.LANDLORD */.Z.LANDLORD,
                control: /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.ZP, {
                  disabled: !creditReportOptionValue
                })
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LegalRestrictionContainer, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledText, {
              color: style_constants/* COLOR.textBlack */.r$.textBlack,
              weight: 400,
              margin: "0",
              mMargin: "0",
              children: "* Screening reports by"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TuLogoWrapper, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(icon/* default */.Z, {
                iconName: "tu-logo-with-name",
                size: 24,
                width: 24,
                height: 24
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkStyled, _objectSpread(_objectSpread({
              id: "screening-restriction-link",
              "data-testid": "screening-restriction-link",
              href: legal_restrictions_link/* LEGAL_RESTRICTIONS_LINK */.o,
              target: "_blank"
            }, screeningRestrictionEventData), {}, {
              children: "Screening Restrictions"
            }))]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(div/* default */.Z, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(UnderLine, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(button_set_v2/* default */.Z, {
            primaryButton: {
              id: "submit-option-button",
              dataTestId: "submit-option-button",
              text: "Next",
              variant: "contained",
              type: "submit",
              eventData: mapEventAttribute()
            }
          })]
        })]
      })
    })
  });
};

/* harmony default export */ var screening_option_form_v2 = (ScreeningOptionFormV2);
;// CONCATENATED MODULE: ./src/components/organisms/screening-option-form-v2/index.js

/* harmony default export */ var organisms_screening_option_form_v2 = (screening_option_form_v2);
// EXTERNAL MODULE: ./src/stores/tenant-screening/index.js + 1 modules
var tenant_screening = __webpack_require__(76770);
// EXTERNAL MODULE: ./src/constants/route.js
var route = __webpack_require__(88372);
// EXTERNAL MODULE: ./src/utils/partner.js
var utils_partner = __webpack_require__(64679);
// EXTERNAL MODULE: ./src/constants/httpStatus.js
var httpStatus = __webpack_require__(15542);
;// CONCATENATED MODULE: ./src/pages/[partner]/v2/index.js



function v2_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function v2_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? v2_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : v2_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var __N_SSP = true;
function ScreeningPage(props) {
  var router = (0,next_router.useRouter)();
  var partner = router.query.partner;

  var _useRecoilState = (0,recoil/* useRecoilState */.FV)(tenant_screening/* tenantScreeningStateV2 */.c),
      _useRecoilState2 = (0,slicedToArray/* default */.Z)(_useRecoilState, 2),
      tenantScreeningV2 = _useRecoilState2[0],
      setTenantScreeningV2 = _useRecoilState2[1];

  (0,react.useEffect)(function () {
    if (props.screeningRequestProps) {
      setTenantScreeningV2(v2_objectSpread({}, props.screeningRequestProps));
    }
  }, [props.screeningRequestProps]);

  var onSubmit = function onSubmit(data) {
    var screeningOption = data.screeningOption,
        payerType = data.payerType;
    setTenantScreeningV2(v2_objectSpread(v2_objectSpread({}, tenantScreeningV2), {}, {
      screeningOption: screeningOption,
      payerType: payerType
    }));
    router.push("/".concat(partner, "/v2/").concat(route/* PATH.PROPERTY */.m.PROPERTY));
  };

  if (partner && !(0,utils_partner/* isPartner */.U)(partner)) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(error["default"], {
      statusCode: httpStatus/* httpStatusCode.NOT_FOUND */.E.NOT_FOUND
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(screening_step_v2/* default */.Z, {
    mb: "30",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typography/* Title */.Dx, {
      size: "20px",
      mt: "0",
      mb: "20",
      children: "Select screening items"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(organisms_screening_option_form_v2, {
      partner: partner,
      value: tenantScreeningV2,
      onSubmit: onSubmit
    })]
  });
}

/***/ }),

/***/ 43002:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[partner]/v2",
      function () {
        return __webpack_require__(68478);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [583,349,716,39,350,61,774,888,179], function() { return __webpack_exec__(43002); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);